import * as React from "react";
import { AppBar, ToggleThemeButton, UserMenu, Logout } from "react-admin";
import Logo from "../components/Logo";
import Search from "./Search/Search";
import { lightTheme, darkTheme } from "./Theme";
import { getRoles } from 'src/common/AuthFunctions';
import { Chip } from "@mui/material";
import { RoleEnum } from "src/common/enum/RoleEnum";

export const AdminRoles = () => (
  <div style={{ 
    padding: '6px 16px 12px',
    borderBottom: '1px solid #e9eaeb',
    marginBottom: '6px',
    display: 'flex',
    gap: '6px',
    flexDirection: 'column'
  }}>
    {getRoles().map((roleId) => {
      return (
        <Chip
          key={roleId}
          label={RoleEnum.find((x) => x.id === roleId)?.name}
        />
      );
    })}
  </div>
)

export const TopBar = (props) => {
  return (
    <AppBar
      sx={{
        "& .RaAppBar-title": {
          flex: 1,
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          overflow: "hidden",
        },
      }}
      {...props}
      userMenu={
        <UserMenu>
            <AdminRoles />
            <Logout />
        </UserMenu>
      }
    >
      <Logo style={{ marginLeft: "20px" }} />

      <span style={{ flex: 1 }} />
      <Search />
      <ToggleThemeButton lightTheme={lightTheme} darkTheme={darkTheme} />
    </AppBar>
  );
};
